module.exports = __webpack_public_path__ + "img/britannica-academic.09ad8e4b.png";